<template>
  <div class="database-list-modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content database-list-modal">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h3>Formular aus Datenbankstruktur importieren</h3>
          <form @submit.prevent="save()">
            <p class="explenation">
              Wählen Sie eine vorhandene Datenbank aus, um die Felder direkt in
              das Formular zu übernehmen.
            </p>

            <div class="database-dropdown-wrapper">
              <generalDropdown
                className="filter-dropdown"
                v-if="getCustomDatabases.length"
              >
                <template v-slot:selectFilter>
                  <span class="line-clamp">{{ getSelectedDatabase }} </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="database in getCustomDatabases"
                    @click="selectDatabase(database)"
                  >
                    {{ database.caption }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
              <p
                class="no-items"
                v-if="
                  getCustomDatabases.length === 0 || showDatabaseSelectWarning
                "
              >
                {{
                  showDatabaseSelectWarning
                    ? 'Bitte wählen Sie die Datenbank'
                    : 'Es gibt keine Datenbanken'
                }}
              </p>
            </div>
            <div class="footer">
              <button
                class="btn-black"
                type="submit"
                :class="{ 'loading-btn': isLoading }"
                :disabled="isLoading"
              >
                <span v-if="!isLoading"> Übernehmen </span>
                <div class="loader" v-else>
                  <b-spinner label="Spinning" small></b-spinner>
                </div>
              </button>
              <button
                class="btn-black"
                type="button"
                @click="close"
                :disabled="isLoading"
              >
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralDropdown from '../core/general-dropdown.vue';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { mapGetters } from 'vuex';
import { getDataBaseTableSchema } from '../../services/userTable';
export default {
  name: 'databaseSchemaSelect',
  data() {
    return {
      selelectedDatabse: null,
      isLoading: false,
      showDatabaseSelectWarning: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async save() {
      try {
        if (this.selelectedDatabse) {
          this.isLoading = true;
          const findDatabase = this.databaseList.find(
            (database) => database.name === this.selelectedDatabse.name
          );
          if (findDatabase && findDatabase.schema) {
            this.$emit('save', JSON.parse(findDatabase.schema));
          } else {
            const response = await getDataBaseTableSchema(
              this.selelectedDatabse.name,
              true
            );
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
              this.$emit('save', JSON.parse(response.data.data));
            }
          }
          this.close();
        } else {
          this.showDatabaseSelectWarning = true;
        }
      } catch (error) {
        this.showToaster('etwas ist schiefgelaufen.', 'Fehlerhaft !', 'danger');
      } finally {
        this.isLoading = false;
      }
    },
    selectDatabase(database) {
      this.selelectedDatabse = database;
      this.showDatabaseSelectWarning = false;
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
    }),
    getSelectedDatabase() {
      return this.selelectedDatabse
        ? this.selelectedDatabse.caption
        : 'Datenbank auswählen ';
    },
    getCustomDatabases() {
      return this.databaseList.filter(
        (database) =>
          database.type === 'custom' && database.access_level != 'read'
      );
    },
  },
  components: {
    GeneralDropdown,
    LoadingSpinner,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.database-list-modal-wrapper .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.database-list-modal-wrapper .modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 30%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  position: fixed;
  left: 35%;
  top: 7%;
  height: fit-content;
  overflow: unset; /*For dropdown*/
}

.database-list-modal-wrapper .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.database-list-modal-wrapper h3 {
  color: #70787e;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.database-list-modal-wrapper .tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}

.database-list-modal-wrapper .pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.database-list-modal-wrapper .btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 2px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 20px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  width: 155px;
}

.database-list-modal-wrapper .btn-black:hover {
  color: #fff;
  border: 2px solid #353434;
  background-color: #353434;
}

.database-list-modal-wrapper p {
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #70787e;
  margin: 25px 0px 25px 0px;
}

.database-list-modal-wrapper .tab .explenation {
  font-size: 13px;
  margin: 0 0 10px 0;
}

.database-list-modal-wrapper
  .modal
  .content
  .tab
  .filter-dropdown
  ::v-deep
  .btn {
  width: fit-content;
  padding: 0;
  margin-bottom: 10px;
}
.database-list-modal-wrapper .database-list-modal ::v-deep .dropdown-menu {
  width: 100%;
}

.database-list-modal-wrapper .database-dropdown-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.database-list-modal-wrapper .no-items {
  margin: 0px 0px 10px 0px !important;
}
.database-list-modal-wrapper .filter-dropdown {
  width: 100%;
}
.database-list-modal-wrapper .filter-dropdown .line-clamp {
  width: unset;
}
.database-list-modal-wrapper .footer {
  display: flex;
  justify-content: flex-start;
  column-gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}
</style>
